import { Component, OnInit,Renderer, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { CommonUtility, CaseNotes, SINGLE_ROW_HEADER } from '../shared';
import { DateUtility, ServerConstantsService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

@Component({
  selector: 'app-case-notes',
  templateUrl: './case-notes.component.html',
  styleUrls: ['./case-notes.component.scss']
})
export class CaseNotesComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('headerText') headerText:ElementRef;
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  caseNotes: CaseNotes;
  caseNotesPrev: CaseNotes;
  serverCaseNotes: CaseNotes;
  tabIndex:any ="-1";

  serverConstants: any;
  userActionNotificationsMap: any;
  refData: any;

  caseNoteMap: any;
  caseNoteArray: any[];

  caseNoteHead = '';
  wpPersonId = '';
  notesSize = 0;

  editable: Boolean = false;
  nonEditable: Boolean = false;
  isView: Boolean = true;
  sharedData: any;
  isChangeDetected:boolean;

  constructor(
   
    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtility: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if(this.dataService.getSharedDataObject().get('CSNTS') == undefined){
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {

    this.sharedData = this.dataService.getSharedDataObject();
   
    this.caseNoteArray = this.data.getValueFromSharedDataMap('CASENOTE_ACTIVITY_TYPES');
    this.caseNoteMap = this.commonUtil.createMapFromList(this.caseNoteArray);
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);
   

    this.caseNotes = this.sharedData.get('caseNotes');
    this.wpPersonId = this.sharedData.get('wpPersonId');
    this.load();



  }
  focusing(event){
    const elem = event.target;
    if ((elem.id === 'caseNotesDiv' || elem.id === 'field_content') && this.isView) return;
    if(!event.shiftKey && event.keyCode==9){
      event.preventDefault();
    setTimeout(() => this.headerText.nativeElement.focus(), 0);
    this.headerText.nativeElement.click();
    }
  }
  
  restrictSpecial(event){
    if((/[<>{}]/.test(event.key))){
      event.returnValue = false;
      return;
     }
      event.returnValue = true;
  }

  load() {
    if (this.caseNotes !== null && this.caseNotes !== undefined && this.caseNotes.id !== undefined) {
      if (this.caseNotes.notes != null && this.caseNotes.notes !== undefined) {
        this.notesSize = this.caseNotes.notes.length;
      }
      this.caseNotes.createdDt = this.dateUtility.convertDateFromServer(this.caseNotes.createdDt);
      this.caseNotesPrev = Object.assign({}, this.caseNotes);
      this.caseNoteHead = "Display";
      this.editable = true;
      this.nonEditable = true;
      this.tabIndex = "0";
      this.isView = false;
     
    } else {
      this.caseNoteHead = "Add";
      this.caseNotes = new CaseNotes();
      this.caseNotesPrev = new CaseNotes();
      this.caseNotes.personId = Number(this.wpPersonId);
      this.caseNotes.createdBy = this.sharedData.get("current_user_full_name");
      this.caseNotes.createdDt = this.getSystemDateFromModel();
      this.caseNotes.deleteSw = 'N';
      this.caseNotes.notes="";
      this.caseNotesPrev = Object.assign({}, this.caseNotes);
    }
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isChangeDetected) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };


  save() {
    setTimeout(() => this.headerText.nativeElement.focus(), 0);
    this.headerText.nativeElement.click();
    this.isChangeDetected = false;
    this.modalPopupService.setChangeDetected(false);
    const request  =  Object.assign({}, this.caseNotes);
    request.createdDt = this.dateUtility.convertDateForServer(this.caseNotes.createdDt);
    this.http.post<CaseNotes>(this.serverConstants.SERVER_API_URL + '/casenotes/save', request)
      .subscribe(
        (res: CaseNotes) => {
          if (res.hasOwnProperty('errorCode')) {
            this.notificationService.error('Case Notes', this.userActionNotificationsMap.ERROR);
          } else { 
            this.router.navigate(['task/caseNotesSummary']);
            this.notificationService.success('Case Notes', this.userActionNotificationsMap.UPDATE);
          }
        },
        (response) => {
          this.notificationService.error('this.caseNotes', this.userActionNotificationsMap.ERROR);
        },
        () => {
        });
  }

 

  public onQuickTextChanged($event) {
    this.notesSize = this.caseNotes.notes.length;
  }

  getSystemDateFromModel() {
    const sysDate = new Date();
    return {
      year: sysDate.getFullYear(),
      month: sysDate.getMonth() + 1,
      day: sysDate.getDate()
    };
  }

  reset() {
   this.load();
  }
}



// WEBPACK FOOTER //
// ./src/app/case-notes/case-notes.component.ts